import { render, staticRenderFns } from "./DSEyeIcon.vue?vue&type=template&id=6b80e7cc&scoped=true&"
import script from "./DSEyeIcon.vue?vue&type=script&lang=js&"
export * from "./DSEyeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b80e7cc",
  null
  
)

export default component.exports